@if (btnPromptsMode) {
	<app-print-email-prompt
		[finresourceObj]="objectRow"
		(onClose)="onClose.emit()"
	/>
} @else if (headtureRow && objectRow) {
	<div class="finresource-translation">
		<app-table-wrap fieldsStr="field_name,heb,en">
			<tr>
				<td>{{ "paid_by" | langVal }}</td>
				<td [innerHTML]="objectRow.paid_by | safeHtml"></td>
				<td>
					<app-gen-input
						[actualObj]="objectRow"
						[errors]="errors"
						title_ph_lang="to"
						fieldName="paid_by_en"
						(keyupEvent)="validateEntireForm()"
					>
					</app-gen-input>
				</td>
			</tr>
			<tr>
				<td>{{ "for" | langVal }}</td>
				<td [innerHTML]="objectRow.description | safeHtml"></td>
				<td>
					<app-gen-input
						[actualObj]="objectRow"
						[errors]="errors"
						title_ph_lang="for"
						fieldName="description_en"
						(keyupEvent)="validateEntireForm()"
					>
					</app-gen-input>
				</td>
			</tr>
			@if (has_payment_details) {
				<tr>
					<td>{{ "payment_details" | langVal }}</td>
					<td [innerHTML]="objectRow.payment_details | safeHtml"></td>
					<td
						style="text-align: left"
						dir="ltr"
					>
						<app-wysiwyg
							[actualObj]="objectRow"
							[errors]="errors"
							style="transform: rotateX(deg0) !important"
							fieldName="payment_details_en"
							title_ph_lang="payment_details"
							[maxHeight]="200"
							(changeEvent)="validateEntireForm()"
						>
						</app-wysiwyg>
					</td>
				</tr>
			}
			<tr>
				<td>{{ "remarks" | langVal }}</td>
				<td [innerHTML]="objectRow.remarks | safeHtml"></td>
				<td>
					<app-gen-input
						[actualObj]="objectRow"
						[errors]="errors"
						title_ph_lang="remarks"
						fieldName="remarks_en"
						(keyupEvent)="validateEntireForm()"
					>
					</app-gen-input>
				</td>
			</tr>
		</app-table-wrap>
	</div>

	<div class="modal-btns">
		<app-cancel-btn (click)="onClose.emit()" />
		<app-btn-ext
			(clickEv)="openPreview()"
			[disabled]="!isFormSubmittable"
			text="create_a_translated_certified_copy"
		/>
	</div>
}
@if (isPreviewOpen) {
	<app-preview-finresource
		(onClose)="isPreviewOpen = false; onClose.emit($event)"
		[headtureRow]="headtureRow"
		[finresourceObj]="objectRow"
		[doctype]="objectRow.doctype"
		isEn
		isDownloadOnly
	/>
}
@if (isGetHeadtureOpen) {
	<app-get-headture-row
		isTranslation
		(onDone)="headtureRow = $event"
	/>
}
